import { useTranslation } from 'react-i18next';

const NotificationsCrumb = () => {
    const { t } = useTranslation();
    return <>{t('userSettings.notifications.title')}</>;
};

export default NotificationsCrumb;
